import { useMyQuery } from "../Authorization/reactQueryWrappers";

// eslint-disable-next-line no-unused-vars
const MOCK = {
  content: [
    {
      username: "hr1@gmail.com",
      firstName: "Scott",
      lastName: "Owen",
      attended: 1,
      booked: 3,
    },
    {
      username: "user10@gmail.com",
      firstName: "Kate",
      lastName: "Smith",
      attended: 7,
      booked: 10,
    },
    {
      username: "user7@gmail.com",
      firstName: "Joe",
      lastName: "Francis",
      attended: 0,
      booked: 0,
    },
  ],
  pageable: {
    pageNumber: 0,
    pageSize: 25,
    sort: {
      empty: false,
      sorted: true,
      unsorted: false,
    },
    offset: 0,
    paged: true,
    unpaged: false,
  },
  last: true,
  totalElements: 5,
  totalPages: 1,
  first: true,
  size: 25,
  number: 0,
  sort: {
    empty: false,
    sorted: true,
    unsorted: false,
  },
  numberOfElements: 5,
  empty: false,
};

export const useReportSessionsQuery = ({ from }) => {
  return useMyQuery({
    queryKey: ["report-sessions", from],
    fetchDef: {
      method: "POST",
      url: "/api/latest/report-sessions",
      payload: {
        from: from ? from.toISOString() : undefined,
      },
      // to: always(MOCK),
    },
  });
};
